import React from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import getMode from "../actions/modeActions";
import "./Navbar.css";
const Navbar = () => {
  const dispatch = useDispatch();
  var mode = localStorage.getItem("mode");
  const changeMode = () => {
    if (mode === "dark") {
      localStorage.setItem("mode", "light");
      dispatch(getMode("light"));
    } else {
      localStorage.setItem("mode", "dark");
      dispatch(getMode("dark"));
    }
  };

  return (
    <div className={mode !== "dark" ? "navbar outer" : "navbar darkouter"}>
      <Link to="/" style={{textAlign:'center'}}>
        <div className={mode !== "dark" ? "logo" : "darklogo"} style={{fontFamily:'Helvetica',display:'flex',flexDirection:"row",justifyContent:'flex-start', fontSize:'3vh'}}>CryptoStats<i className="registered outline icon"></i></div>
      </Link>
      <Link to="/" style={{textAlign:'center'}}>
        <div className={mode !== "dark" ? "inner" : "darkinner"}>
          Money Markets
        </div>
      </Link>

      <Link to="/historicalroi">
        <div className={mode !== "dark" ? "inner" : "darkinner"} style={{textAlign:'center'}}>
          Historical ROI
        </div>
      </Link>

      <Link to="/convertcommunity">
        <div className={mode !== "dark" ? "inner" : "darkinner"} style={{textAlign:'center'}}>
          Currency & Community
        </div>
      </Link>
      <Link>
        <div
          className={mode !== "dark" ? "inner" : "darkinner"}
          onClick={changeMode}
          style={{textAlign:'center'}}
        >
          <span>Switch</span> <span>Mode</span>
        </div>
      </Link>
    </div>
  );
};

export default Navbar;
